"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GameScenarioEnum = void 0;
var GameScenarioEnum;
(function (GameScenarioEnum) {
  /** Сценарии для словарного запаса */
  /** словарный запас, открытые карточки */
  GameScenarioEnum[GameScenarioEnum["opencard"] = 1] = "opencard";
  /** словарный запас, карточки "да/нет" */
  GameScenarioEnum[GameScenarioEnum["truefalse"] = 2] = "truefalse";
  /** прослушать термин, выбрать определение */
  GameScenarioEnum[GameScenarioEnum["listen_term"] = 3] = "listen_term";
  /** прослушать определение, выбрать термин */
  GameScenarioEnum[GameScenarioEnum["listen_definition"] = 4] = "listen_definition";
  /** посмотреть определение, выбрать термин */
  GameScenarioEnum[GameScenarioEnum["choice_term"] = 5] = "choice_term";
  /** посмотреть термин, выбрать определение */
  GameScenarioEnum[GameScenarioEnum["choice_definition"] = 6] = "choice_definition";
  /** посмотреть определение, написать термин */
  GameScenarioEnum[GameScenarioEnum["write_term"] = 7] = "write_term";
  /** посмотреть определение, произнести термин */
  GameScenarioEnum[GameScenarioEnum["say_term"] = 8] = "say_term";
  /** Игровые сценарии */
  /** без ошибок */
  GameScenarioEnum[GameScenarioEnum["without_fail"] = 20] = "without_fail";
  /** до третьей ошибки */
  GameScenarioEnum[GameScenarioEnum["third_fail"] = 21] = "third_fail";
  /** длиннейший страйк (непрерывная серия правильных ответов) */
  GameScenarioEnum[GameScenarioEnum["longest_streak"] = 22] = "longest_streak";
  /** на количество баллов (за ошибки баллы не начисляются) */
  GameScenarioEnum[GameScenarioEnum["points"] = 23] = "points";
  /**
   * на скорость (за правильный ответ увеличение допустимого таймаута ответа,
   * за ошибки увеличенние таймаута между слайдами)
   */
  GameScenarioEnum[GameScenarioEnum["speed"] = 24] = "speed";
})(GameScenarioEnum = exports.GameScenarioEnum || (exports.GameScenarioEnum = {}));
